export const DATE_UNIT = {
   DAY: 'day',
   MONTH: 'month',
   YEAR: 'year',
   SECOND: 'second',
   MINUTE: 'minute',
   HOUR: 'hour',
}

export function getDateFormattedAsInTryphon(serverDateFormat: string, unit: string, locale: string): string {
    return getMommentFormat(serverDateFormat, unit, locale) ?? ''
}

function getMommentFormat(serverDateFormat: string, unit: string, locale: string) {
    switch (locale) {
       case 'de':
          return getDeFormat(unit)
       case 'fr':
          return getFrFormat(unit)
       case 'en':
       case 'en-us':
          return getMommentFormatEn(unit, serverDateFormat)
       case 'fr-ca':
          return getFrCAFormat(unit)
       default:
          return getFrFormat(unit)
    }
}

function getMommentFormatEn(unit: string, serverDateFormat: string) {
    switch (serverDateFormat) {
       case 'MM/DD/YYYY':
          return getEnUsFormat(unit)
       case 'YYYY/MM/DD':
          return getEnFormat(unit)
       case 'DD/MM/YYYY':
          return getFrFormat(unit)
       case 'MM-DD-YYYY':
          return getFormatWithSlashMMDDYYYY(unit)
       case 'YYYY-MM-DD':
          return getFrCAFormat(unit)
       case 'DD-MM-YYYY':
          return getFormatWithSlashDDMMYYYY(unit)
    }
 }

function getEnUsFormat(unit: string) {
    switch (unit) {
       case 'day':
          return 'MM/DD/Y'
       case 'month':
          return 'MM/Y'
       case 'year':
          return 'Y'
       case 'second':
          return 'MM/DD/Y HH:mm:ss'
       case 'minute':
          return 'MM/DD/Y HH:mm'
       case 'hour':
          return 'MM/DD/Y HH'
    }
}

function getEnFormat(unit: string) {
    switch (unit) {
       case 'day':
          return 'Y/MM/DD'
       case 'month':
          return 'Y/MM'
       case 'year':
          return 'Y'
       case 'second':
          return 'Y/MM/DD HH:mm:ss'
       case 'minute':
          return 'Y/MM/DD HH:mm'
       case 'hour':
          return 'Y/MM/DD HH'
    }
}

function getDeFormat(unit: string) {
    switch (unit) {
       case 'day':
          return 'Y.MM.DD'
       case 'month':
          return 'Y.MM'
       case 'year':
          return 'Y'
       case 'second':
          return 'DD.MM.Y HH:mm:ss'
       case 'minute':
          return 'DD.MM.Y HH:mm'
       case 'hour':
          return 'DD.MM.Y HH'
    }
}

function getFrFormat(unit: string) {
    switch (unit) {
       case 'day':
          return 'DD/MM/Y'
       case 'month':
          return 'MM/Y'
       case 'year':
          return 'Y'
       case 'second':
          return 'DD/MM/Y HH:mm:ss'
       case 'minute':
          return 'DD/MM/Y HH:mm'
       case 'hour':
          return 'DD/MM/Y HH'
    }
}

function getFrCAFormat(unit: string) {
    switch (unit) {
       case 'day':
          return 'Y-MM-DD'
       case 'month':
          return 'Y-MM'
       case 'year':
          return 'Y'
       case 'second':
          return 'Y-MM-DD HH:mm:ss'
       case 'minute':
          return 'Y-MM-DD HH:mm'
       case 'hour':
          return 'Y-MM-DD HH'
    }
}

function getFormatWithSlashMMDDYYYY(unit: string) {
    switch (unit) {
       case 'day':
          return 'MM-DD-Y'
       case 'month':
          return 'MM-Y'
       case 'year':
          return 'Y'
       case 'second':
          return 'MM-DD-Y HH:mm:ss'
       case 'minute':
          return 'MM-DD-Y HH:mm'
       case 'hour':
          return 'MM-DD-Y HH'
    }
}

function getFormatWithSlashDDMMYYYY(unit: string) {
    switch (unit) {
       case 'day':
          return 'DD-MM-Y'
       case 'month':
          return 'MM-Y'
       case 'year':
          return 'Y'
       case 'second':
          return 'DD-MM-Y HH:mm:ss'
       case 'minute':
          return 'DD-MM-Y HH:mm'
       case 'hour':
          return 'DD-MM-Y HH'
    }
}